import { Injectable } from '@angular/core'
import { HttpUtil } from 'src/service/common.http'
import { HandleError, HttpErrorHandler } from 'src/service/http-error-handler.service'
import { StoreResult } from './product.model'
import { catchError } from 'rxjs/operators'
@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private http: HttpUtil, private httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('StoreService')
  }
  private urlConfig = {
    search: () => '/a/7moor/spu/search',
    classify: '/a/7moor/classify/search',
  }

  private handleError: HandleError

  getProductList(params): Promise<StoreResult> {
    params.merchantId = localStorage.getItem('merchantId') || ''
    params.token = localStorage.getItem('token') || ''
    return this.http
      .get(this.urlConfig.search(), { params })
      .pipe(catchError(this.handleError('getProductList')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }

  getClassifys(params): Promise<any> {
    params.merchantId = localStorage.getItem('merchantId') || ''
    params.token = localStorage.getItem('token') || ''
    return this.http
      .get(this.urlConfig.classify, { params })
      .pipe(catchError(this.handleError('getClassifys')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }
}
